import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-edit-overlay',
  templateUrl: './edit-overlay.component.html',
  styleUrls: ['./edit-overlay.component.scss'],
  standalone: true,
  imports: [MatTooltipModule],
})
export class EditOverlayComponent {
  @Input() tooltipText: string = '';
  @Output() editClick = new EventEmitter<void>(); // Emit an event on click

  // Method to handle click event
  handleClick(event: MouseEvent) {
    event.stopPropagation(); // Prevent the event from bubbling up
    this.editClick.emit(); // Emit the event
  }
}
